<template>
	<div class="sub-values">
		<div class="sub-value">
			<div class="label">Monatsgehalt (Brutto - Vollzeitbasis)</div>
			<template v-if="data && data.salary">{{ data.salary }} &euro;</template>
			<template v-else>Laut Kollektivvertrag/Mindest-Gehaltsregeln</template>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		job: {
			type: Object,
			required: true,
		},
		data: {
			type: Object,
			required: false,
		},
	},
}
</script>
